import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsMultiNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M16.188 14.413c.176.104.377.158.582.157a1.138 1.138 0 00.99-.61l.65-1.22a.317.317 0 01.28-.17h2.48v-1.35h-2.48a1.671 1.671 0 00-1.45.89l-.44.83-1.66-3.11a1.147 1.147 0 00-1.579-.426c-.176.102-.32.25-.421.426l-.65 1.22a.32.32 0 01-.29.17h-2v1.37h2a1.681 1.681 0 001.48-.88l.44-.84 1.65 3.11c.097.18.242.33.418.433z"
        fill=""
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.38 20.22a8.25 8.25 0 11.964-16.443c.287.033.573.081.856.143l-.011.048a8.273 8.273 0 012.384-.163c.358.028.714.08 1.066.156l.222-.052.145-.03a8.251 8.251 0 019.864 8.091 8.259 8.259 0 01-10.039 8.054l.009.036a8.254 8.254 0 01-3.86-.016 8.238 8.238 0 01-1.6.176zM6.106 6.196c.41-.41.858-.77 1.336-1.082a6.904 6.904 0 00-5.625 4.702 6.898 6.898 0 005.319 8.921 8.25 8.25 0 01-1.03-12.54zm5.011 12.687l-.074-.049a8.25 8.25 0 01-.148-13.627 6.896 6.896 0 00-4.883 3.261 6.899 6.899 0 005.105 10.415zm.68-12.65a6.898 6.898 0 013.832-1.163v.02a6.908 6.908 0 016.9 6.88 6.9 6.9 0 11-10.733-5.737z"
        fill=""
      />
    </svg>
  )
);
SvgSportsMultiNormalSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgSportsMultiNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsMultiNormalSmall;
